import { createRecipe } from './runtime';

const scrollbarConfig = {"name":"scrollbar"}

export const scrollbar = /* @__PURE__ */ createRecipe(scrollbarConfig)